import React from "react";
import { useFullscreenContext } from "../common/withFullscreen";

interface NodeContentSectionProps {
  children: React.ReactNode;
  className?: string;
  hasRelative?: boolean;
  scrollable?: boolean;
  onWheel?: (e: React.WheelEvent) => void;
}

const NodeContentSection: React.FC<NodeContentSectionProps> = ({
  children,
  className = "",
  hasRelative = false,
  onWheel,
}) => {
  const { isFullscreen } = useFullscreenContext();
  const heightClasses = isFullscreen ? "h-full min-h-0" : "h-[60vh]";
  const layoutClasses = "overflow-hidden flex flex-col";
  const relativeClass = hasRelative ? "relative" : "";

  // Remove "col-span-4" — width is now controlled by the parent flex container
  const baseClasses =
    "border shadow-md rounded-md p-2 nodrag nowheel cursor-default";

  return (
    <div
      className={`${baseClasses} ${heightClasses} ${layoutClasses} ${relativeClass} ${className}`.trim()}
      onWheel={onWheel || ((e) => e.stopPropagation())}
    >
      {children}
    </div>
  );
};

export default NodeContentSection;
